import { useResetPassword } from '@ztechapps/common.hook'

export const useTemplateResetPassword = () => {
  const { executeIt } = useResetPassword()

  const resetPassword = async ({ _id }) => {
    const result = await executeIt({ _id })
    return result?.data?.resetPassword
  }

  return { resetPassword }
}
